<span class="c-field-value" [ngClass]="customClass">
  <span class="c-field-value__text">
    <p500-ui-icon class="c-field-value__icon fw-bold" [class.is-active]="isActive" name="check" size="16px"></p500-ui-icon>
    <ng-container *ngIf="isActive" i18n="@@common.yes">Yes</ng-container>
    <ng-container *ngIf="!isActive" i18n="@@common.no">No</ng-container>
  </span>
</span>
